import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { ClientFormFields } from './ClientForm';

export const ClientEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<MyToolbar resource="clients" />}>
      <MyFormContainer>
        <ClientFormFields isCreate={false} />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default ClientEdit;
